module.exports = __webpack_public_path__ + "img/speaker_with_gradient_green.07c1d9d0.png";